import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { AlertService } from "../components/alert/alert.service";
import { Router } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, Validators } from '@angular/forms';
import { SubscriptionService } from "../subscription/subscription.service";
import { ReCaptchaV3Service } from 'ngx-captcha';

@Component({
  selector: 'app-team-collaboration',
  templateUrl: './team-collaboration.component.html',
  styleUrls: ['./team-collaboration.component.css']
})
export class TeamCollaborationComponent implements OnInit {

  constructor(
    private alert: AlertService,
    private router: Router,
    private titleService: Title,
    private metaTagService: Meta,
    private modalService: NgbModal,
    private fb: FormBuilder,
    private subscriptionService: SubscriptionService,
    private reCaptchaV3Service: ReCaptchaV3Service,
    private cdr: ChangeDetectorRef,
  ) { }

  showTime: boolean = false;
  showFinalTime: boolean = false;
  showSubmitBtn: boolean = false;
  shownTime: string;
  showDate: boolean = true;
  shownDate: string;
  shownMonth: string;
  shownDay: string;
  timeSelected: boolean = false;
  dateSelected: boolean = false;
  availableTimeSlots = [];
  availableSlots = [];
  selectedTime: any;
  selectedDate: any;
  thankYouText: string = "Thank you, select date for a quick call.";
  userName: string;
  userEmail: string;
  companyName: string;
  date: string;
  time: string;

  isShowError: boolean = false;
  isDateSelected: boolean = false;
  isTimeSelected: boolean = false;
  showSelectionMessage: boolean = false;
  showLeaveLoader: boolean = false;
  showSelectedMsg: string;
  sendingProcessStyle = "none";

  public siteKey?: string = '6Lf59_gUAAAAAEJNHrHp1Vdd1LaG1epuOF62yj80';
  public token?: string;
  public siteKeyV2: string = "6Lf4BvkUAAAAAKreyepy8vMm4ttzZtXIY_0xVJ0O";
  type: string = "checkbox";

  @ViewChild('letsTalk') letsTalk;
  @ViewChild('selectDate') selectDate;
  @ViewChild('showloader') showloader;
  @ViewChild('thankyou') thankyou;

  letsTalkForm = this.fb.group({
    name: ['', Validators.required],
    lname: ['', Validators.required],
    message: ['Storage page DAM(inside)', Validators.required],
    email: ['', [Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"), Validators.required]],
    company: ['', Validators.required],
  });

  submitted: Boolean = false;
  reload: Boolean = true;
  aFormGroup: any;


  ngOnInit(): void {
    this.titleService.setTitle("Project teams | Workspace | Crafttor");
    this.metaTagService.addTags([
      { name: 'description', content: 'Crafttor Workspace enhance capability of storing your assets, files smartly by optimizing storage efficiency, better performance and provide seamless accessibility.'},
      { name: 'keywords', content: 'storage, free storage, storage for free, store files' },
      { name: 'robots', content: 'index, follow' },
      { name: 'author', content: 'Crafttor' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { charset: 'UTF-8' }
    ]);
  }

  openMarketplace() {
    window.open("https://crafttor.com/marketplace", "_blank");
  }

  openLetsTalkDialog(modal){
      this.letsTalk = this.modalService.open(modal, { centered: true, windowClass: 'sign-up ' });
  }

  openThankskDialog(modal){
      this.thankyou = this.modalService.open(modal, { centered: true, windowClass: 'thanks-popup ' });
  }

  openSelectTimeDialog(modal){
      this.selectDate = this.modalService.open(modal, { centered: true, windowClass: 'select-time-popup ' });
  }

  public submitContactUs(modal) {
    this.submitted = true;
    if (this.letsTalkForm.valid) {
      this.showLeaveLoader = true;
      this.reCaptchaV3Service.execute(this.siteKey, 'contact_us', (token) => {
        this.letsTalkForm.value['recaptcha'] = token;
        this.cdr.detectChanges();
        this.userName = this.letsTalkForm.value['name'] +" "+this.letsTalkForm.value['lname'];
        this.userEmail = this.letsTalkForm.value['email'];
        this.companyName = this.letsTalkForm.value['company'] +" : " +this.letsTalkForm.value['message'];
        this.date = this.letsTalkForm.value['date'];
        this.time = this.letsTalkForm.value['time_start'];
        this.letsTalkForm.reset()
        this.letsTalk.close();
        this.showLeaveLoader = false;
        this.getDateListApi();
        this.selectDate = this.modalService.open(modal, { centered: true, windowClass: 'select-time-popup ' });
      });
    }
  }

  getDateListApi() {
    this.subscriptionService.getDateCall().subscribe((data: any) => {
      this.availableSlots = data;
      this.getTimeListApi(data[0].date);
    });
  }

  getTimeListApi(date: any) {
    this.subscriptionService.getTimeCall(date).subscribe((data: any) => {
      this.availableTimeSlots = data;
    });
  }

  contactSalesCall(modal) {
    if(this.isDateSelected == true && this.isTimeSelected == true) {
      this.sendingProcessStyle = "block";
       this.subscriptionService.contactSalesCallApi(this.userName, this.userEmail, this.companyName,
         this.selectedDate, this.selectedTime).subscribe((data) => {
         this.showLeaveLoader = false;
         this.submitted = false;
         this.sendingProcessStyle = "none";
         this.openThankskDialog(modal);
       },(error: any) => {
         if(error.status == 400){
           this.showLeaveLoader = false;
           this.submitted = false;
           this.sendingProcessStyle = "none";
           this.alert.error(error.error.message);
         } else {
           this.showLeaveLoader = false;
           this.submitted = false;
           this.sendingProcessStyle = "none";
           this.alert.error(error.error.message);
         }
      });
    } else if(this.isDateSelected == false) {
      this.showLeaveLoader = false;
      this.showSelectionMessage = true;
      this.showSelectedMsg = "Select Date";
    } else if(this.isTimeSelected == false) {
      this.showLeaveLoader = false;
      this.showSelectionMessage = true;
      this.showSelectedMsg = "Select Time";
    }
  }

  goToWorkspace() {
    this.thankyou.close();
    this.router.navigate(['/dam']);
  }

  closeThankDialog(){
    this.thankyou.close();
  }

  selectDateSales(date: string, day: string, month: string) {
    this.selectedDate = date;
    this.showDate = false;
    this.isDateSelected = true;
    this.dateSelected = true;
    this.showSubmitBtn = true;
    this.showSelectionMessage = false;
    this.thankYouText = "Thank You!! select time."

    this.getTimeListApi(date);
    this.showTime = true;
    this.timeSelected = false;
    this.showFinalTime = false;

    this.shownMonth = month;
    if(day == 'Mon') {
      this.shownDay = "Monday";
    } else if(day == 'Tue') {
      this.shownDay = "Tuesday";
    } else if(day == 'Wed') {
      this.shownDay = "Wednesday";
    } else if(day == 'Thu') {
      this.shownDay = "Thursday";
    } else if(day == 'Fri') {
      this.shownDay = "Friday";
    } else if(day == 'Sat') {
      this.shownDay = "Saturday";
    } else if(day == 'Sun') {
      this.shownDay = "Sunday";
    }

    let stringToSplit = this.selectedDate;
    let splitDate = stringToSplit.split("-");

    if(splitDate[1] == '01') {
      this.shownDate = "Jan" +" "+ splitDate[2] +", "+splitDate[0];
    } else if(splitDate[1] == '02') {
      this.shownDate = "Feb" +" "+ splitDate[2] +", "+splitDate[0];
    } else if(splitDate[1] == '03') {
      this.shownDate = "March" +" "+ splitDate[2] +", "+splitDate[0];
    } else if(splitDate[1] == '04') {
      this.shownDate = "April" +" "+ splitDate[2] +", "+splitDate[0];
    } else if(splitDate[1] == '05') {
      this.shownDate = "May" +" "+ splitDate[2] +", "+splitDate[0];
    } else if(splitDate[1] == '06') {
      this.shownDate = "June" +" "+ splitDate[2] +", "+splitDate[0];
    } else if(splitDate[1] == '07') {
      this.shownDate = "Julu" +" "+ splitDate[2] +", "+splitDate[0];
    } else if(splitDate[1] == '08') {
      this.shownDate = "Aug" +" "+ splitDate[2] +", "+splitDate[0];
    } else if(splitDate[1] == '09') {
      this.shownDate = "Sept" +" "+ splitDate[2] +", "+splitDate[0];
    } else if(splitDate[1] == '10') {
      this.shownDate = "Oct" +" "+ splitDate[2] +", "+splitDate[0];
    } else if(splitDate[1] == '11') {
      this.shownDate = "Nov" +" "+ splitDate[2] +", "+splitDate[0];
    } else if(splitDate[1] == '12') {
      this.shownDate = "Dec" +" "+ splitDate[2] +", "+splitDate[0];
    }
  }

  changeDate() {
    this.showDate = true;
    this.isDateSelected = false;
    this.dateSelected = false;
    this.showSubmitBtn = false;
    this.showSelectionMessage = false;
    this.showTime = false;
    this.isTimeSelected = false;
    this.timeSelected = false;
    this.showFinalTime = false;
    // this.getTimeListApi(this.availableSlots[0].date);
  }

  selectTimeSales(time) {
    this.selectedTime = time;
    this.showTime = false;
    this.showSubmitBtn = true;
    this.shownTime = time;
    this.showFinalTime = true;
    this.isTimeSelected = true;
    this.showSelectionMessage = false;
    this.timeSelected = true;
    this.thankYouText = "Thank You!! you meeting will be scheduled."
  }

  changeTime() {
    this.showTime = true;
    this.isTimeSelected = false;
    this.timeSelected = false;
    this.showSelectionMessage = false;
  }
}
